// Public and restricted can be used in RO and other technologies

export const WATER_TYPE_FILTERS = t => [
  { category: "water", label: t("moduleFilter.drinking_water"), value: "drinking_water" },
  { category: "water", label: t("moduleFilter.non_drinking_water"), value: "non_drinking_water" },
];

export const RACK_TYPE_FILTERS = t => [
  { category: "rack", label: t("moduleFilter.rack"), value: "rack" },
  { category: "rack", label: t("moduleFilter.open_platform"), value: "open_platform" },
];

export const ADDITIONAL_FILTER_CATEGORY_TYPES = t => [
  { category: "obsolete", label: t("moduleFilter.obsolete"), value: "obsolete" },
  { category: "chinese", label: t("moduleFilter.chinese"), value: "chinese" },
];

export const INGE_FILTER_CATEGORIES = t => [...RACK_TYPE_FILTERS(t), ...ADDITIONAL_FILTER_CATEGORY_TYPES(t)];

export const DUPONT_FILTER_CATEGORIES = t => [
  ...RACK_TYPE_FILTERS(t),
  ...WATER_TYPE_FILTERS(t),
  ...ADDITIONAL_FILTER_CATEGORY_TYPES(t),
];

export const DEFAULT_DUPONT_FILTER_CATEGORIES = t => [...RACK_TYPE_FILTERS(t), ...WATER_TYPE_FILTERS(t)];

export const DEFAULT_MODULE_FILTER_CATEGORIES = t => ({
  1: DEFAULT_DUPONT_FILTER_CATEGORIES(t),
  2: RACK_TYPE_FILTERS(t),
});

export const MODULE_FILTER_CATEGORIES = t => ({
  1: DUPONT_FILTER_CATEGORIES(t),
  2: INGE_FILTER_CATEGORIES(t),
});
